// Translations
import en from "./en.json"

export default {
    language: 'en',
    resources: {en}
}
